import React, { ReactNode } from 'react'
import styles from './cardParts.module.sass'

// The pieces of text most cards share, so every section draws them the same way.

// The small grey line under a card's title saying what it measures.
export const Metric = ({ text }: { text: string }) => <p className={styles.metric}>{text}</p>

// The plain-language paragraph over a card's footer.
export const Meaning = ({ text }: { text: string }) => <p className={styles.meaning}>{text}</p>

// The bold takeaway under the figures; nothing when there's nothing to say.
export const Note = ({ text }: { text: string | null }) => {
  if (!text) return null

  return <p className={styles.note}>{text}</p>
}

// A shaded box standing in for figures there aren't yet.
export const Message = ({ title, text }: { title: string; text: string }) => (
  <div className={styles.message}>
    <p className={styles.messageTitle}>{title}</p>
    <p className={styles.messageText}>{text}</p>
  </div>
)

// Out of sight, still read out: a label for screen readers only.
export const VisuallyHidden = ({ children }: { children: ReactNode }) => <span className={styles.visuallyHidden}>{children}</span>
